export const returnArrayOrSingleElementArray = <T,>(v: T | T[]): T[] =>
  Array.isArray(v) ? v : [v];
